import React from "react";

import {
	Box,
	Checkbox,
	TableCell,
	TableHead,
	TableRow,
	TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";

import Body2 from "../../typography/body-02";

import styles from "./index.module.scss";

import "./mui-styles.scss";

const TableHeadLoanDocumentsTracker = (props) => {
	const {
		data,
		// sort
		order,
		orderBy,
		onRequestSort,
		selectedCount,
		rowCount,
		onSelectAllClick,
	} = props;

	const createSortHandler = (headCell) => (event) => {
		onRequestSort(event, headCell.id);
	};

	return (
		<TableHead>
			<TableRow
				sx={{
					"& th": {
						py: 0.15,
					},
				}}
			>
				<TableCell padding="checkbox">
					<Checkbox
						className={styles.checkboxContainer}
						indeterminate={selectedCount > 0 && selectedCount < rowCount}
						checked={rowCount > 0 && selectedCount === rowCount}
						onChange={onSelectAllClick}
						aria-label="select all documents"
					/>
				</TableCell>
				{data.map((headCell) => (
					<TableCell
						key={headCell.id}
						align={headCell.numeric ? "right" : "left"}
						padding={headCell.disablePadding ? "none" : "normal"}
						sortDirection={orderBy === headCell.id ? order : false}
						style={{ minWidth: headCell.minWidth }}
					>
						{headCell.id !== "actions" ? (
							<TableSortLabel
								active={orderBy === headCell.id}
								direction={orderBy === headCell.id ? order : "asc"}
								onClick={createSortHandler(headCell)}
							>
								<Body2
									text={headCell.label}
									extraClass={styles.thText}
									fontType="semibold"
								/>
								{orderBy === headCell.id ? (
									<Box component="span" sx={visuallyHidden}>
										{order === "desc"
											? "sorted descending"
											: "sorted ascending"}
									</Box>
								) : null}
							</TableSortLabel>
						) : (
							<Body2
								text={headCell.label}
								extraClass={styles.thText}
								fontType="semibold"
							/>
						)}
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
};

export default TableHeadLoanDocumentsTracker;
